import permissions from "../constants/permissions";
import InventoryModuleLayout from "@/views/Pages/InventoryModule/InventoryModuleLayout.vue";

// import middleware
import authenticated from "@/middleware/authenticated";
import authorized from "@/middleware/authorized";

// import pages
const ListProductPage = () =>
  import("@/views/Pages/InventoryModule/ProductManagement/ListProductPage.vue");
const AddProductPage = () =>
  import("@/views/Pages/InventoryModule/ProductManagement/AddProductPage.vue");
const EditProductPage = () =>
  import("@/views/Pages/InventoryModule/ProductManagement/EditProductPage.vue");
const ViewProductPage = () =>
  import("@/views/Pages/InventoryModule/ProductManagement/ViewProductPage.vue");

const ListUnitOfMeasurePage = () =>
  import(
    "@/views/Pages/InventoryModule/UnitOfMeasureManagement/ListUnitOfMeasurePage.vue"
  );
const AddUnitOfMeasurePage = () =>
  import(
    "@/views/Pages/InventoryModule/UnitOfMeasureManagement/AddUnitOfMeasurePage.vue"
  );
const EditUnitOfMeasurePage = () =>
  import(
    "@/views/Pages/InventoryModule/UnitOfMeasureManagement/EditUnitOfMeasurePage.vue"
  );
const ViewUnitOfMeasurePage = () =>
  import(
    "@/views/Pages/InventoryModule/UnitOfMeasureManagement/ViewUnitOfMeasurePage.vue"
  );

const ListWarehousePage = () =>
  import(
    "@/views/Pages/InventoryModule/WarehouseManagement/ListWarehousePage.vue"
  );
const AddWarehousePage = () =>
  import(
    "@/views/Pages/InventoryModule/WarehouseManagement/AddWarehousePage.vue"
  );
const EditWarehousePage = () =>
  import(
    "@/views/Pages/InventoryModule/WarehouseManagement/EditWarehousePage.vue"
  );
const ViewWarehousePage = () =>
  import(
    "@/views/Pages/InventoryModule/WarehouseManagement/ViewWarehousePage.vue"
  );

const ListStockMovementPage = () =>
  import(
    "@/views/Pages/InventoryModule/StockMovementManagement/ListStockMovementPage.vue"
  );
const AddStockMovementPage = () =>
  import(
    "@/views/Pages/InventoryModule/StockMovementManagement/AddStockMovementPage.vue"
  );
const EditStockMovementPage = () =>
  import(
    "@/views/Pages/InventoryModule/StockMovementManagement/EditStockMovementPage.vue"
  );
const ViewStockMovementPage = () =>
  import(
    "@/views/Pages/InventoryModule/StockMovementManagement/ViewStockMovementPage.vue"
  );

const ListEstablishmentTransferPage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentTransferManagement/ListEstablishmentTransferPage.vue"
  );
const AddEstablishmentTransferPage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentTransferManagement/AddEstablishmentTransferPage.vue"
  );
const EditEstablishmentTransferPage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentTransferManagement/EditEstablishmentTransferPage.vue"
  );
const ViewEstablishmentTransferPage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentTransferManagement/ViewEstablishmentTransferPage.vue"
  );

const ListEquipmentTransferPage = () =>
  import(
    "@/views/Pages/InventoryModule/EquipmentTransferManagement/ListEquipmentTransferPage.vue"
  );
const AddEquipmentTransferPage = () =>
  import(
    "@/views/Pages/InventoryModule/EquipmentTransferManagement/AddEquipmentTransferPage.vue"
  );
const EditEquipmentTransferPage = () =>
  import(
    "@/views/Pages/InventoryModule/EquipmentTransferManagement/EditEquipmentTransferPage.vue"
  );
const ViewEquipmentTransferPage = () =>
  import(
    "@/views/Pages/InventoryModule/EquipmentTransferManagement/ViewEquipmentTransferPage.vue"
  );

const ListEstablishmentInternalInvoicePage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentInternalInvoiceManagement/ListEstablishmentInternalInvoicePage.vue"
  );
const AddEstablishmentInternalInvoicePage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentInternalInvoiceManagement/AddEstablishmentInternalInvoicePage.vue"
  );
const EditEstablishmentInternalInvoicePage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentInternalInvoiceManagement/EditEstablishmentInternalInvoicePage.vue"
  );
const ViewEstablishmentInternalInvoicePage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentInternalInvoiceManagement/ViewEstablishmentInternalInvoicePage.vue"
  );
const ListEstablishmentInternalOrderPage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentInternalOrderManagement/ListEstablishmentInternalOrderPage.vue"
  );
const AddEstablishmentInternalOrderPage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentInternalOrderManagement/AddEstablishmentInternalOrderPage.vue"
  );
const EditEstablishmentInternalOrderPage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentInternalOrderManagement/EditEstablishmentInternalOrderPage.vue"
  );
const ViewEstablishmentInternalOrderPage = () =>
  import(
    "@/views/Pages/InventoryModule/EstablishmentInternalOrderManagement/ViewEstablishmentInternalOrderPage.vue"
  );

const ListCategoryPage = () =>
  import(
    "@/views/Pages/InventoryModule/CategoryManagement/ListCategoryPage.vue"
  );
const AddCategoryPage = () =>
  import(
    "@/views/Pages/InventoryModule/CategoryManagement/AddCategoryPage.vue"
  );
const EditCategoryPage = () =>
  import(
    "@/views/Pages/InventoryModule/CategoryManagement/EditCategoryPage.vue"
  );
const ViewCategoryPage = () =>
  import(
    "@/views/Pages/InventoryModule/CategoryManagement/ViewCategoryPage.vue"
  );
const InventoryPage = () =>
  import("@/views/Pages/InventoryModule/InventoryPage.vue");
const InventoryTrainingPage = () =>
  import("@/views/Pages/InventoryModule/InventoryTrainingPage.vue");

const ListSupplyRulePage = () =>
  import(
    "@/views/Pages/InventoryModule/SupplyRuleManagement/ListSupplyRulePage.vue"
  );
const AddSupplyRulePage = () =>
  import(
    "@/views/Pages/InventoryModule/SupplyRuleManagement/AddSupplyRulePage.vue"
  );
const EditSupplyRulePage = () =>
  import(
    "@/views/Pages/InventoryModule/SupplyRuleManagement/EditSupplyRulePage.vue"
  );
const ViewSupplyRulePage = () =>
  import(
    "@/views/Pages/InventoryModule/SupplyRuleManagement/ViewSupplyRulePage.vue"
  );


  const ListCategoryEquipmentPage = () =>
    import(
      "@/views/Pages/InventoryModule/CategoryEquipmentManagement/ListCategoryEquipmentPage.vue"
    );
  const AddCategoryEquipmentPage = () =>
    import(
      "@/views/Pages/InventoryModule/CategoryEquipmentManagement/AddCategoryEquipmentPage.vue"
    );
  const EditCategoryEquipmentPage = () =>
    import(
      "@/views/Pages/InventoryModule/CategoryEquipmentManagement/EditCategoryEquipmentPage.vue"
    );
  const ViewCategoryEquipmentPage = () =>
    import(
      "@/views/Pages/InventoryModule/CategoryEquipmentManagement/ViewCategoryEquipmentPage.vue"
    );


    const ListEquipmentPage = () =>
      import(
        "@/views/Pages/InventoryModule/EquipmentManagement/ListEquipmentPage.vue"
      );
    const AddEquipmentPage = () =>
      import(
        "@/views/Pages/InventoryModule/EquipmentManagement/AddEquipmentPage.vue"
      );
    const EditEquipmentPage = () =>
      import(
        "@/views/Pages/InventoryModule/EquipmentManagement/EditEquipmentPage.vue"
      );
    const ViewEquipmentPage = () =>
      import(
        "@/views/Pages/InventoryModule/EquipmentManagement/ViewEquipmentPage.vue"
      );
  



let productManagementPages = {
  path: "products",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List Products",
      components: { default: ListProductPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_PRODUCTS,
      },
    },
    {
      path: "add",
      name: "Add Product",
      components: { default: AddProductPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_PRODUCTS,
      },
    },
    {
      path: "edit/:id",
      name: "Edit Product",
      components: { default: EditProductPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_PRODUCTS,
      },
    },
    {
      path: "view/:id",
      name: "View Product",
      components: { default: ViewProductPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_PRODUCTS,
      },
    },
  ],
};

let supplyRuleManagementPages = {
  path: "supply-rules",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List Supply Rules",
      components: { default: ListSupplyRulePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_SUPPLY_RULES,
      },
    },
    {
      path: "add",
      name: "Add Supply Rule",
      components: { default: AddSupplyRulePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_SUPPLY_RULES,
      },
    },
    {
      path: "edit/:id",
      name: "Edit Supply Rule",
      components: { default: EditSupplyRulePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_SUPPLY_RULES,
      },
    },
    {
      path: "view/:id",
      name: "View Supply Rule",
      components: { default: ViewSupplyRulePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_SUPPLY_RULES,
      },
    },
  ],
};

let warehouseManagementPages = {
  path: "warehouses",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List Warehouses",
      components: { default: ListWarehousePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_WAREHOUSES,
      },
    },
    {
      path: "add",
      name: "Add Warehouse",
      components: { default: AddWarehousePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_WAREHOUSES,
      },
    },
    {
      path: "edit/:id",
      name: "Edit Warehouse",
      components: { default: EditWarehousePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_WAREHOUSES,
      },
    },
    {
      path: "view/:id",
      name: "View Warehouse",
      components: { default: ViewWarehousePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_WAREHOUSES,
      },
    },
  ],
};

let categoryManagementPages = {
  path: "categories",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List Categories",
      components: { default: ListCategoryPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_CATEGORIES,
      },
    },
    {
      path: "add",
      name: "Add Category",
      components: { default: AddCategoryPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_CATEGORIES,
      },
    },
    {
      path: "edit/:id",
      name: "Edit Category",
      components: { default: EditCategoryPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_CATEGORIES,
      },
    },
    {
      path: "view/:id",
      name: "View Category",
      components: { default: ViewCategoryPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_CATEGORIES,
      },
    },
  ],
};

let stockMovementManagementPages = {
  path: "stock-movements",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List StockMovements",
      components: { default: ListStockMovementPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_STOCK_MOVEMENTS,
      },
    },
    {
      path: "add",
      name: "Add StockMovement",
      components: { default: AddStockMovementPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_STOCK_MOVEMENTS,
      },
    },
    {
      path: "edit/:id",
      name: "Edit StockMovement",
      components: { default: EditStockMovementPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_STOCK_MOVEMENTS,
      },
    },
    {
      path: "view/:id",
      name: "View StockMovement",
      components: { default: ViewStockMovementPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_STOCK_MOVEMENTS,
      },
    },
  ],
};

let establishmentTransferManagementPages = {
  path: "establishment-transfers",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List EstablishmentTransfers",
      components: { default: ListEstablishmentTransferPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_ESTABLISHMENT_TRANSFERS,
      },
    },
    {
      path: "add",
      name: "Add EstablishmentTransfer",
      components: { default: AddEstablishmentTransferPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_ESTABLISHMENT_TRANSFERS,
      },
    },
    {
      path: "edit/:id",
      name: "Edit EstablishmentTransfer",
      components: { default: EditEstablishmentTransferPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_ESTABLISHMENT_TRANSFERS,
      },
    },
    {
      path: "view/:id",
      name: "View EstablishmentTransfer",
      components: { default: ViewEstablishmentTransferPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ESTABLISHMENT_TRANSFERS,
      },
    },
  ],
};

let equipmentTransferManagementPages = {
  path: "equipment-transfers",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List EquipmentTransfers",
      components: { default: ListEquipmentTransferPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_EQUIPMENT_TRANSFERS,
      },
    },
    {
      path: "add",
      name: "Add EquipmentTransfer",
      components: { default: AddEquipmentTransferPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_EQUIPMENT_TRANSFERS,
      },
    },
    {
      path: "edit/:id",
      name: "Edit EquipmentTransfer",
      components: { default: EditEquipmentTransferPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_EQUIPMENT_TRANSFERS,
      },
    },
    {
      path: "view/:id",
      name: "View EquipmentTransfer",
      components: { default: ViewEquipmentTransferPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_EQUIPMENT_TRANSFERS,
      },
    },
  ],
};

let establishmentInternalInvoiceManagementPages = {
  path: "establishment-internal-invoices",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List EstablishmentInternalInvoices",
      components: { default: ListEstablishmentInternalInvoicePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_ESTABLISHMENT_INTERNAL_INVOICES,
      },
    },
    {
      path: "add",
      name: "Add EstablishmentInternalInvoice",
      components: { default: AddEstablishmentInternalInvoicePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_ESTABLISHMENT_INTERNAL_INVOICES,
      },
    },
    {
      path: "edit/:id",
      name: "Edit EstablishmentInternalInvoice",
      components: { default: EditEstablishmentInternalInvoicePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_ESTABLISHMENT_INTERNAL_INVOICES,
      },
    },
    {
      path: "view/:id",
      name: "View EstablishmentInternalInvoice",
      components: { default: ViewEstablishmentInternalInvoicePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ESTABLISHMENT_INTERNAL_INVOICES,
      },
    },
  ],
};

let establishmentInternalOrderManagementPages = {
  path: "establishment-internal-orders",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List EstablishmentInternalOrders",
      components: { default: ListEstablishmentInternalOrderPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_ESTABLISHMENT_INTERNAL_ORDERS,
      },
    },
    {
      // Moved to the dashboard module: old links and bookmarks still work.
      path: "daily-preparations",
      redirect: (to) => ({ name: "Internal Preparations", query: to.query }),
    },
    {
      path: "add",
      name: "Add EstablishmentInternalOrder",
      components: { default: AddEstablishmentInternalOrderPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_ESTABLISHMENT_INTERNAL_ORDERS,
      },
    },
    {
      path: "edit/:id",
      name: "Edit EstablishmentInternalOrder",
      components: { default: EditEstablishmentInternalOrderPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_ESTABLISHMENT_INTERNAL_ORDERS,
      },
    },
    {
      path: "view/:id",
      name: "View EstablishmentInternalOrder",
      components: { default: ViewEstablishmentInternalOrderPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ESTABLISHMENT_INTERNAL_ORDERS,
      },
    },
  ],
};

let unitOfMeasureManagementPages = {
  path: "unit-of-measures",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List UnitOfMeasures",
      components: { default: ListUnitOfMeasurePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_PRODUCTS,
      },
    },
    {
      path: "add",
      name: "Add UnitOfMeasure",
      components: { default: AddUnitOfMeasurePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_PRODUCTS,
      },
    },
    {
      path: "edit/:id",
      name: "Edit UnitOfMeasure",
      components: { default: EditUnitOfMeasurePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_PRODUCTS,
      },
    },
    {
      path: "view/:id",
      name: "View UnitOfMeasure",
      components: { default: ViewUnitOfMeasurePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_PRODUCTS,
      },
    },
  ],
};


let categoryEquipmentManagementPages = {
  path: "category-equipments",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List CategoryEquipments",
      components: { default: ListCategoryEquipmentPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_CATEGORIES,
      },
    },
    {
      path: "add",
      name: "Add CategoryEquipment",
      components: { default: AddCategoryEquipmentPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_CATEGORIES,
      },
    },
    {
      path: "edit/:id",
      name: "Edit CategoryEquipment",
      components: { default: EditCategoryEquipmentPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_CATEGORIES,
      },
    },
    {
      path: "view/:id",
      name: "View CategoryEquipment",
      components: { default: ViewCategoryEquipmentPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_CATEGORIES,
      },
    },
  ],
};



let equipmentManagementPages = {
  path: "equipments",
  component: InventoryModuleLayout,
  children: [
    {
      path: "",
      name: "List Equipments",
      components: { default: ListEquipmentPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_EQUIPMENTS,
      },
    },
    {
      path: "add",
      name: "Add Equipment",
      components: { default: AddEquipmentPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_EQUIPMENTS,
      },
    },
    {
      path: "edit/:id",
      name: "Edit Equipment",
      components: { default: EditEquipmentPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_EQUIPMENTS,
      },
    },
    {
      path: "view/:id",
      name: "View Equipment",
      components: { default: ViewEquipmentPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_EQUIPMENTS,
      },
    },
  ],
};





const inventoryModuleRoutes = [
  {
    path: "",
    component: InventoryModuleLayout,
    children: [
      {
        path: "",
        name: "Inventory Page",
        components: { default: InventoryPage },
        meta: { middleware: authenticated },
      },
      {
        path: "training",
        name: "Inventory Training",
        components: { default: InventoryTrainingPage },
        meta: { middleware: authenticated },
      },
    ],
  },
  productManagementPages,
  unitOfMeasureManagementPages,
  warehouseManagementPages,
  stockMovementManagementPages,
  establishmentTransferManagementPages,
  equipmentTransferManagementPages,
  establishmentInternalInvoiceManagementPages,
  establishmentInternalOrderManagementPages,
  supplyRuleManagementPages,
  categoryManagementPages,
  categoryEquipmentManagementPages,
  equipmentManagementPages
];

export default inventoryModuleRoutes;
